module.exports = __webpack_public_path__ + "fonts/iconfont.b7d0f01.woff";